import React, { useContext, useEffect, useState } from "react";
import { Link, } from "react-router-dom";
import SideBar from "../SideBar/SideBar";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";

const Header = () => {
  const { authUser, authId, SignOut } = useContext(AuthContext);
  const [isOpen, setIsopen] = useState(false);

  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };



  const SignOutFun = () => {

    fetch(`https://api.velormall.com/api/admin/auth/logout/${authUser?._id}?deviceId=${authId?.deviceId}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) {
          SignOut();
          toast.error(`logout succssfully`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }


      });



  };


  const [menuSHow, setMenuShow] = useState(false);

  const handleShow = () => {
    setMenuShow(true);
  };


  useEffect(() => {

    const script = document.createElement('script');
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"

    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
          includedLanguages: "en,zh-CN,zh-TW",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
        },
        "google_translate_element"
      );
    };
    document.body.appendChild(script);
    window.googleTranslateElementInit = googleTranslateElementInit;


  }, []);



  const [liveChatData, setLiveChatData] = useState(0)

  useEffect(() => {
    try {
      const interval = setInterval(() => {
        fetchLiveChatData();
      }, 2000);
      return () => clearInterval(interval);
    } catch (error) {

    }
  }, [liveChatData]);


  const fetchLiveChatData = async () => {
    try {
      fetch(`https://chat-api.wlfmobile.com/api/admin/notification/view/${authUser?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setLiveChatData(data?.PendingLiveChats);
          }

        })
        .catch((error) => {
          // console.log(error);
        });
    } catch (error) {

    }
  };


  //
  return (
    <>
      <nav className="navbar-wrapper bg--dark">
        <div className="navbar__left">
          <button className="res-sidebar-open-btn me-3" onClick={handleShow}>
            <i className="las la-bars"></i>
          </button>
          <form className="navbar-search">
            <input
              type="search"
              name="#0"
              className="navbar-search-field"
              id="searchInput"
              autoComplete="off"
              placeholder="Search here..."
            />
            <i className="las la-search"></i>
            <ul className="search-list"></ul>
          </form>
        </div>
        <div className="navbar__right">
          <ul className="navbar__action-list">
            <li className="dropdown">
              <div id="google_translate_element"></div>
            </li>

            {/*  */}

            <li className="dropdown">
              <button
                onClick={ToggleSidebar}
                className=""
                data-bs-toggle="dropdown"
                data-display="static"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="navbar-user">
                  <span className="navbar-user__thumb">
                    <img
                      src={
                        authUser?.picture
                          ? `https://api.velormall.com/${authUser?.picture}`
                          : ""
                      }
                      alt=""
                    />
                  </span>
                  <span className="navbar-user__info">
                    <span className="navbar-user__name">{authUser?.name}</span>
                  </span>
                  <span className="icon">
                    <i className="las la-chevron-circle-down"></i>
                  </span>
                </span>
              </button>
              <div
                className={`dropdown-menu dropdown-menu--sm p-0 border-0 box--shadow1 dropdown-menu-right ${isOpen === true ? "admin-profile-dropdown-menu" : ""
                  } `}
              >

                <button
                  onClick={() => SignOutFun()}
                  className="dropdown-menu__item d-flex align-items-center px-3 py-2"
                >
                  <i className="dropdown-menu__icon las la-sign-out-alt text-dark"></i>
                  <span className="dropdown-menu__caption">Logout</span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <SideBar menuSHow={menuSHow} setMenuShow={setMenuShow} />
    </>
  );
};

export default Header;
